import { Route, Router, Switch, withRouter } from 'react-router';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';

import List from './List';
import CreateSmsForm from './CreateSmsForm';

const Roles = ({ history, match }) => (
  <DataGridStateContextProvider>
    <Router history={history}>
      <Switch>
        <Route
          exact={true}
          path={`${match.url}/`}
          render={parentProps => <List history={history} {...parentProps} />}
        />
        <Route
          path={`${match.url}/add`}
          render={() => <CreateSmsForm history={history} />}
        />
      </Switch>
    </Router>
  </DataGridStateContextProvider>
);

export default withRouter(Roles);
